import { render } from "./Experience.vue?vue&type=template&id=2f746b37&scoped=true"
import script from "./Experience.vue?vue&type=script&lang=js"
export * from "./Experience.vue?vue&type=script&lang=js"

import "./Experience.vue?vue&type=style&index=0&id=2f746b37&scoped=true&lang=css"

import exportComponent from "/Users/LeonardoMBP/Documents/GitHub/swagible-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f746b37"]])

export default __exports__